import React, {useRef, useState} from 'react';
import styled, {css} from 'styled-components';

import {colors} from '@/constants/theme';
import {ReactComponent as Icon} from '@/assets/svg/arrow_question.svg';
import {ParamsType} from '@/modules/Product/components/Main/components/Tabs/Tabs';
import {getChildNode} from '@/modules/Product/components/Main/components/Tabs/components/Collapse/helpres';
import {getCurrentProject} from "@/utils/common";

type Props = {
  type: string;
  label: string;
  data: ParamsType[] | any;
};

function Collapse({data, type, label}: Props) {
  const [isOpen, setOpen] = useState(getCurrentProject() === 'dveri');
  const [height, setHeight] = useState(0);

  const ref = useRef<HTMLDivElement>(null);

  const clickHandler = () => {
    setOpen((prev) => !prev);
  };

  const Child = getChildNode(type);

  return (
    <Tab>
      <Header
        className="params-collapse-header"
        active={isOpen}
        onClick={clickHandler}
      >
        <Label>{label}</Label>
        <StyledIcon/>
      </Header>
      <CollapseWrapper>
        <Children ref={ref} active={isOpen} size={height}>
          {Child ? <Child data={data} setHeight={setHeight}/> : null}
        </Children>
      </CollapseWrapper>
    </Tab>
  );
}

export default Collapse;

const Tab = styled.div``;
const Label = styled.span`
  width: 75%;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
`;
const Header = styled.div<{ active: boolean }>`
  padding: 10px 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > svg {
    transition: transform 0.2s ease;
  }

  ${({active}) =>
    active &&
    css`
      & > span {
        color: ${colors.primary};
      }

      & > svg {
        transform: rotate(-180deg);
      }

      & > svg path {
        fill: ${colors.primary};
      }

      background: ${colors.gray50};
      border-bottom: 1px solid ${colors.gray70};
    `}
`;
const CollapseWrapper = styled.div`
  overflow: hidden;
  padding: 0 15px;
`;

const Children = styled.div<{ active: boolean; size: number }>`
  transition: height 0.2s ease, margin 0.2s ease;
  ${({active, size}) =>
    active
      ? css`
        height: ${size}px;
        margin-top: 9px;
      `
      : css`
        height: 0;
        margin-top: 0;
      `}
`;
const StyledIcon = styled(Icon)``;
